import {
    CompositionContentType,
    CompositionLayoutType,
    TCompositionContentTypesWithoutCompanyInfo
} from '~/types/builder.types';

export const CONTENT_TYPE_TO_SECTION_TITLE: Record<
    TCompositionContentTypesWithoutCompanyInfo,
    string
> = {
    [CompositionContentType.Composition]: 'CONTENT LAYOUTS',
    [CompositionContentType.Image]: 'IMAGE LAYOUTS',
    [CompositionContentType.CanvaImage]: 'IMAGE LAYOUTS',
    [CompositionContentType.Question]: 'QUESTION LAYOUTS',
    [CompositionContentType.Text]: 'TEXT LAYOUTS',
    [CompositionContentType.Video]: 'VIDEO LAYOUTS'
};

export const DEFAULT_LAYOUT_PER_CONTENT_TYPE: Record<
    TCompositionContentTypesWithoutCompanyInfo,
    CompositionLayoutType
> = {
    [CompositionContentType.Composition]: CompositionLayoutType.IconAndText,
    [CompositionContentType.Image]: CompositionLayoutType.OneImage,
    [CompositionContentType.CanvaImage]: CompositionLayoutType.OneImage,
    [CompositionContentType.Question]: CompositionLayoutType.OneQuestion,
    [CompositionContentType.Text]: CompositionLayoutType.TextOnly,
    [CompositionContentType.Video]: CompositionLayoutType.OneVideo
};

const imageLayoutOrder = {
    [CompositionLayoutType.OneImage]: 1,
    [CompositionLayoutType.TwoImages]: 2,
    [CompositionLayoutType.ImageGrid]: 3,
    [CompositionLayoutType.ImageAndText]: 4,
    [CompositionLayoutType.ImagesAndTextGrid]: 5,
    [CompositionLayoutType.ImagesAndText]: 6,
    [CompositionLayoutType.LeftImageAndText]: 7,
    [CompositionLayoutType.ImageAndQuestions]: 8,
    [CompositionLayoutType.IconAndText]: 9,
    [CompositionLayoutType.Splash]: 10,
    [CompositionLayoutType.ImageApproval]: 11,
    [CompositionLayoutType.ImageSelection]: 12
};

export const CONTENT_TYPES_LAYOUTS_ORDER: Record<
    TCompositionContentTypesWithoutCompanyInfo,
    Partial<Record<CompositionLayoutType, number>>
> = {
    // Do not start order at 0 because it won't pass falsey test
    [CompositionContentType.Composition]: {
        [CompositionLayoutType.OneQuestion]: 1,
        [CompositionLayoutType.IconAndText]: 2,
        [CompositionLayoutType.Splash]: 3,
        [CompositionLayoutType.VideoAndText]: 4,
        [CompositionLayoutType.ImageAndText]: 5,
        [CompositionLayoutType.ImageAndQuestions]: 6,
        [CompositionLayoutType.TextAndQuestions]: 7,
        [CompositionLayoutType.Questionnaire]: 8,
        [CompositionLayoutType.Form]: 9,
        [CompositionLayoutType.TextApproval]: 10,
        [CompositionLayoutType.ImageApproval]: 11,
        [CompositionLayoutType.ImageGrid]: 12,
        [CompositionLayoutType.ImagesAndTextGrid]: 13,
        [CompositionLayoutType.TitleAndText]: 14,
        [CompositionLayoutType.TwoColumnText]: 15,
        [CompositionLayoutType.TwoImages]: 16,
        [CompositionLayoutType.LeftImageAndText]: 17,
        [CompositionLayoutType.ImagesAndText]: 18,
        [CompositionLayoutType.TextAndVideo]: 19
    },
    [CompositionContentType.Image]: imageLayoutOrder,
    [CompositionContentType.CanvaImage]: imageLayoutOrder,
    [CompositionContentType.Question]: {
        [CompositionLayoutType.OneQuestion]: 1,
        [CompositionLayoutType.Questionnaire]: 2,
        [CompositionLayoutType.Form]: 3,
        [CompositionLayoutType.TextApproval]: 4,
        [CompositionLayoutType.ImageApproval]: 5,
        [CompositionLayoutType.ImageSelection]: 6,
        [CompositionLayoutType.TextAndQuestions]: 7,
        [CompositionLayoutType.ImageAndQuestions]: 8,
        [CompositionLayoutType.UploadQuestion]: 9
    },
    [CompositionContentType.Text]: {
        [CompositionLayoutType.TextOnly]: 1,
        [CompositionLayoutType.TitleAndText]: 2,
        [CompositionLayoutType.TwoColumnText]: 3,
        [CompositionLayoutType.IconAndText]: 4,
        [CompositionLayoutType.ImageAndText]: 5,
        [CompositionLayoutType.VideoAndText]: 6,
        [CompositionLayoutType.Splash]: 7,
        [CompositionLayoutType.TextApproval]: 9,
        [CompositionLayoutType.ImageApproval]: 8
    },
    [CompositionContentType.Video]: {
        [CompositionLayoutType.OneVideo]: 1,
        [CompositionLayoutType.VideoAndText]: 2,
        [CompositionLayoutType.TextAndVideo]: 3
    }
};
